import React from 'react';
import {
  Link,
} from 'react-router-dom';
import * as routes from '../../constants/routes';

const PasswordForgetLink = () =>
  <div>
    <Link to="/pw-forget">Forgot Password?</Link>
  </div>

const SignUpLink = () =>
  <p>
    Don't have an account?
    {' '}
    <Link to={routes.SIGN_UP}>Sign Up</Link>
  </p>

const SignInLink = () =>
  <div>
    Already have an account?
    {' '}
    <Link to={routes.SIGN_IN}>Sign In</Link>
  </div>

const ReturnSignInLink = () => 
  <div>
    <Link to={routes.SIGN_IN}>Return to Sign In</Link>
  </div>

export {
  PasswordForgetLink,
  SignUpLink,
  SignInLink,
  ReturnSignInLink,
};



// WEBPACK FOOTER //
// ./src/components/auth/Links.jsx